export default __webpack_public_path__ + "static/media/errorPleaceholder.6f10a69a.svg";